"use strict";
var import_auto = require("react-native-url-polyfill/auto");
var import_base64Polyfill = require("./base64Polyfill");
//# sourceMappingURL=index.js.map